import _ from 'lodash'

var helpers = {
  simpleStringField: simpleStringField,
  simpleDateField: simpleTypeGenerator('datepicker'),
  simpleDateTimeField: simpleTypeGenerator('datetimepicker'),
  simpleBoolField: simpleTypeGenerator('checkbox'),
  simpleNumberField: numberField,
  simplePercentageField: percentageField,
  simpleCurrencyField: currencyField,
  simpleReadonlyField: simpleReadonlyField,
  textAreaField: textAreaField,
  columnLayout: columnLayout,
  headerField: headerField
}

function headerField(config) {
  return {
    key: config.key,
    type: 'header',
    templateOptions: {
      headerText: config.headerText
    },
    model: {}
  }
}

function simpleStringField(config){
  const field = simpleTypeGenerator('input')(config)
  field.templateOptions.maxlength = config.maxlength
  field.templateOptions.minlength = config.minlength
  return field
}

function simpleReadonlyField(config){
  const readonlyField = simpleTypeGenerator('readonly')(config)
  readonlyField.formatters = config.formatters
  return readonlyField
}

function textAreaField(config) {
  var simpleGenerator = simpleTypeGenerator('textarea')

  var field = simpleGenerator(config)
  field.templateOptions.rows = config.rows || 5

  return field
}

function currencyField(config) {
  var numberType = numberField(config)

  numberType.templateOptions.addonLeft = {
    class: 'fa fa-usd'
  }

  return numberType
}


function percentageField(config) {
  var numberType = numberField(config)

  numberType.templateOptions.addonRight = {
    class: 'fa fa-percent'
  }

  return numberType
}


function numberField(config) {
  var typeConfig = simpleTypeGenerator('input')(config)
  var templateOptions = typeConfig.templateOptions

  templateOptions.type = 'number'
  templateOptions.min = config.min
  templateOptions.max = config.max
  templateOptions.step = config.step

  return typeConfig
}


function simpleTypeGenerator(type) {
  return function (config) {

    var field = {
      key: config.key,
      className: config.className,
      name: config.name || config.key,
      templateOptions: {
        label: config.label || config.key,
        required: !!config.required
      },
      model: config.model,
      defaultValue: config.defaultValue,
      expressionProperties: config.expressionProperties,
      watcher: config.watcher,      
    }

    field.type = type
    return field
  }
}

function columnLayout(fieldDefinitions, columns, noRow) {
  var totalColumns = 12
  var columnSpan = totalColumns / columns
  var chunked = _.chunk(fieldDefinitions, columns)

  var className = 'col-xs-' + columnSpan.toString()

  _.forEach(fieldDefinitions, function (fieldDefinition) {
    fieldDefinition.className = fieldDefinition.className ? `${fieldDefinition.className} ${className}` : className
  })

  return _.map(chunked, function (chunk) {
    return {
      className: noRow ? '' : 'row',
      fieldGroup: chunk
    }
  })
}

export default helpers
